module.exports = __webpack_public_path__ + "media/src/images/icon/update-dcea8a78fd19ab89eead88fbd5d22717.svg";